import $ from "jquery";

export function init() {
	$(document).ready(function () {
		$("#revealButton").click(function () {
			$("#hiddenText").toggleClass("hidden");
		});
	});
}